export default __webpack_public_path__ + "static/media/hht2_storybook_05.f7a0b011.png";